import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const Monitoring = lazy(() => import('../Monitoring'));

const MonitoringRoutes: RouteObject[] = [
  {
    path: 'monitoring',
    element: <Monitoring />,
  },
];

export default MonitoringRoutes;
